/* Insurance — the rules, transcribed.
 *
 * From Financial/Insurance.jsx and Financial/AddInsuranceForm.jsx.
 */

/* Transcribed verbatim, values included: these lowercase strings are what the
   API stores, and the labels are what the design's card reads back. */
export const INSURANCE_TYPES = [
  { value: "employee benefit", label: "Employee Benefit" },
  { value: "marine", label: "Marine" },
  { value: "construction", label: "Construction" },
  { value: "energy", label: "Energy" },
  { value: "speciality lines", label: "Specialty Lines" },
  { value: "trade credit", label: "Trade Credit" },
  { value: "property", label: "Property" },
  { value: "other general lines", label: "Other General Lines" },
];

export const INSURANCE_SPEC = {
  key: "insurance",
  companyListKey: "insuranceDetails",
  joinKey: "insuranceID",
  idKey: "insuranceID",
  draftIdKey: "insurance_draftID",
  draftLinkKey: "insuranceID_id",

  followCreated: "New Insurance Added",
  followUpdated: "Insurance Updated",
  deleteMessage: "Insurance Information Deleted Successfully",
};

/* Transcribed from createArrayFromObject's whitelist and its order. */
export const INSURANCE_ROWS = [
  { key: "type", label: "Type" },
  { key: "insurer", label: "Insurer" },
  { key: "broker", label: "Broker" },
];

/* The stored value back to its label. */
export const insuranceTypeLabel = (value) => {
  const found = INSURANCE_TYPES.find((t) => t.value === value);
  return found ? found.label : value || "";
};

/* Transcribed fallback: the joined broker company's registered name, else the
   plain `broker` string the row carries. A broker is optional, so an empty one
   is normal and the card shows a dash for it. */
export const insuranceBrokerName = (record) =>
  record?.broker_company_ID?.registered_company_name || record?.broker || "";

export const insuranceRowValues = (record = {}) => ({
  type: insuranceTypeLabel(record?.type),
  insurer: record?.insurer || "",
  broker: insuranceBrokerName(record),
});

/* What an existing row seeds the dialog with. */
export const editingInsurance = (record) => ({
  type: record?.type || "",
  insurer: record?.insurer || "",
  insurerCompanyID:
    record?.insurer_company_ID?.companyID || record?.insurer_comp_ID || "",
  broker: insuranceBrokerName(record),
  brokerCompanyID: record?.broker_company_ID?.companyID || "",
});

/* A type and an insurer are required; a broker is not. */
export const validateInsurance = ({ type, insurer }) => {
  const errors = {};
  if (String(type ?? "").trim() === "") errors.type = "Please select a type";
  if (String(insurer ?? "").trim() === "") errors.insurer = "Please specify an insurer";
  return errors;
};

/* Transcribed: a business found only in WorldBox has no TREVEX id, so a
 * company record is created first and the insurance points at it. Same rule
 * the relation sections use, and the same two id spellings.
 */
export const needsCompanyRecord = (chosen) =>
  Boolean(chosen && !chosen.companyID && !chosen.trevex_id && (chosen.win || chosen.wb_win));
